import React from "react";
import Grid from "@material-ui/core/Grid";
import { useInvAF } from "../../../../St/Reviews/UseStyle";
import { ButtonBase } from "@material-ui/core";
import { txtA, txtE } from "../../../../Label/Lbl";
import { useBody } from "../../bill-template02/style";
import QrBarcode from "./QrBarcode";
import tafqeet from "../../../../utils/tafqeet";
import i18next from "i18next";
import { getcolor } from "../../invCompany/A4/UnderHeader";
import "../../AFReadyDisigen/invoiceprint.css"
import { stylePadding } from "../../ShareFunctionsPrint";
function FooterLast(props) {
    const { InvForFatora, found, sta, locInv, premiApp } = props;
    const clas = useInvAF();
    const calssBody = useBody();
    const invColors = sta?.StngIA?.colors;
    const secondColor = getcolor(invColors);

    const styleToltal = {
        border: "solid 0.1px black",
        borderRadius: "6px",
        textAlign: "center",
        color: secondColor,
        fontWeight: "bold",
        padding: 2,
    };

    return (
        <div className="footerview" style={stylePadding}>
        <Grid
            item container style={{
                paddingTop: "0.3rem", fontFamily: "Amiri-Regular",
                direction: i18next.language == "ar" ? "rtl" : "ltr"}}>
            <Grid
                item xs={9}   container className={calssBody.totalItem} spacing={1}
                style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
            >
                <Grid item xs={4} style={styleToltal}>
                    {(sta.tot.tot_net - sta.tot.amountOfVat).toFixed(2)}
                </Grid>
                <Grid item xs={7}>
                    {" الإجمالي  " + " " + txtE.totalAmount}
                </Grid>
                <Grid item xs={4} style={styleToltal}>
                    {sta.tot.discount.toFixed(2)}
                </Grid>
                <Grid item xs={7}>
                    {txtA.discount + " " + txtE.discount}
                </Grid>
                <Grid item xs={4} style={styleToltal}>
                    {sta.tot.amountOfVat.toFixed(2)}
                </Grid>
                <Grid item xs={7}>
                    {"(15%) ضريبة القيمة المضافة VAT"}
                </Grid>
                <Grid item xs={4} style={styleToltal}>
                    {sta.tot.tot_net.toFixed(2)}
                </Grid>
                <Grid item xs={7} style={styleToltal}>
                    <div style={{ fontWeight: "bold", }}>{tafqeet(sta.tot.tot_net, "SAR")}  {"فقط لا غير "} </div>
                </Grid>
            </Grid>
            {locInv?.ProcTypeInvProc != "03" && locInv?.ProcTypeInvProc != "04" &&
                <Grid item xs={3} container>
                    <QrBarcode locInv={locInv} InvForFatora={InvForFatora} color={secondColor} />
                </Grid>
            }
            {premiApp.billTemplate !== 28 && (
                <Grid
                    item
                    container
                    xs={12}
                    spacing={1}
                    style={{ paddingTop: 10, fontWeight: "bold", textAlign: "center" }}
                >
                    <Grid item xs={5}>
                        <div style={{ fontFamily: "Amiri-Regular", fontWeight: "bold" }}> {" توقيع البائع" + "     " + " Salesmans Sign "}</div>
                        <br />
                        {/* <br /> */}
                        {"--------------------"}
                    </Grid>

                    {found?.footer_img != null ?
                        (
                            <Grid item xs={2}>
                                <div>
                                    <ButtonBase>
                                        {" "}
                                        <img
                                            src={`data:image/jpeg;base64,${found?.footer_img}`}
                                            className={clas.Hedlogo}
                                            alt={found.nameA}
                                            style={{ height: 120, width: 120 }}
                                        />{" "}
                                    </ButtonBase>
                                </div>
                            </Grid>
                        ) :
                        (
                            <Grid item xs={2}></Grid>
                        )
                    }
                    <Grid item xs={5}>
                        <div style={{ fontFamily: "Amiri-Regular", fontWeight: "bold" }}> {"توقيع المستلم" + "     " + " Receivrs Sign "}</div>
                        <br />
                        {"--------------------"}
                    </Grid>

                </Grid>
            )}

        </Grid>
        </div>
    );
}
export default FooterLast;
